var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"createCollection"},[_c('el-button',{staticClass:"collected",attrs:{"loading":_vm.loading_icon},on:{"click":_vm.deleteFrontCollection}},[_vm._v("已收藏")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }